import React from 'react'
import PropTypes from 'prop-types'
import Hyperlink from '../../HyperLink'

const BreadcrumbItem = ({ label, path, disabled, showInMobile }) =>
  label ? (
    <li
      className={`my-auto after:my-auto last:after:content-none lg:after:content-['>'] ${
        showInMobile
          ? "inline-flex before:my-auto before:content-['<'] lg:before:content-none"
          : 'hidden lg:inline-flex'
      }`}
    >
      {disabled ? (
        <span
          data-testid="breadcrumb-disabled-item"
          className="ml-5 text-gray-300"
        >
          {label.toUpperCase()}
        </span>
      ) : (
        <Hyperlink
          href={path}
          childrenClassNames="text-black-base lg:pr-5 pl-5"
          data-testid="breadcrumb-item"
          clickTracking={false}
        >
          {label.toUpperCase()}
        </Hyperlink>
      )}
    </li>
  ) : null

BreadcrumbItem.propTypes = {
  showInMobile: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
}

export default React.memo(BreadcrumbItem)
